/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './User/Login',
      },
      {
        name: 'logged-out',
        path: '/user/logged-out',
        component: './User/LoggedOut',
      },
      {
        name: 'resetPassword',
        path: '/user/reset-password',
        component: './User/ResetPassword',
      },
      {
        name: 'forgotPassword',
        path: '/user/forgot-password',
        component: './User/ForgotPassword',
      },
    ],
  },
  {
    path: '/welcome',
    name: 'welcome',
    icon: 'HomeIcon',
    component: './Welcome',
  },
  {
    path: '/grammar-of-use',
    name: 'Grammar of Use',
    icon: 'GrammarOfUseIcon',
    redirect: '/angel-insider?path=grammar-of-use-v1.html',
  },
  {
    path: '/angel-insider/*',
    component: './AngelInsider/index',
    hideInMenu: true,
  },
  {
    name: 'divider',
    path: `__divider__1`,
    hideInMenu: false, // keep it visible
    disabled: true,
    isDivider: true, // custom flag
    title: 'Vault', // text display
  },
  {
    path: '/files/*',
    name: 'files',
    icon: 'FolderIcon',
    component: './Files',
    access: 'canFiles',
  },
  {
    path: '/favourites-hub/*',
    name: 'favouritesHub',
    icon: 'ProjectsHubIcon',
    component: './ProjectsHub',
  },
  {
    path: '/search',
    name: 'search',
    icon: 'SearchIcon',
    component: './Search',
    access: 'canSearch',
  },
  {
    path: '/library',
    name: 'library',
    icon: 'LibraryIcon',
    component: './Library',
    access: 'canLibrary',
  },
  {
    name: 'divider',
    path: `__divider__2`,
    hideInMenu: false, // keep it visible
    disabled: true,
    isDivider: true, // custom flag
    title: 'Chat & Compose', // text display
  },
  {
    path: '/chat/*',
    name: 'chat',
    icon: 'ChatIcon',
    component: './Chat',
    access: 'canChat',
  },
  {
    path: '/transcribe/*',
    name: 'scribe',
    icon: 'ScribeIcon',
    component: './Scribe',
  },
  {
    path: '/workstudio/*',
    name: 'playbook',
    icon: 'WorkstudioIcon',
    component: './Playbook',
    isBeta: true,
    access: 'canChat',
  },
  {
    path: '/translation/*',
    name: 'translation',
    icon: 'TranslationIcon',
    component: './Translation',
    access: 'canTranslation',
  },
  // {
  //   path: '/quote',
  //   name: 'quote',
  //   icon: 'QuoteIcon',
  //   component: './Quote',
  //   isBeta: true, // custom flag
  //   access: 'canQuote',
  // },
  {
    name: 'divider',
    path: `__divider__3`,
    hideInMenu: false, // keep it visible
    disabled: true,
    isDivider: true, // custom flag
    title: 'Specialised', // text display
  },
  {
    path: '/review/*',
    name: 'review',
    icon: 'ReviewIcon',
    component: './Review',
    access: 'canMatrix',
  },
  {
    path: '/comparison/*',
    name: 'comparison',
    icon: 'ComparisonIcon',
    component: './Comparison',
    access: 'canComparison',
  },
  {
    path: '/side-by-side/*',
    name: 'sideBySide',
    icon: 'SideBySideIcon',
    component: './SideBySide',
    access: 'canMatrix',
  },
  {
    path: '/templates',
    name: 'template',
    icon: 'TemplateIcon',
    component: './Template',
    access: 'canTemplate',
  },
  {
    path: '/apps/*',
    name: 'app',
    icon: 'AnalysisIcon',
    component: './App',
    access: 'canAnalysis',
  },
  {
    name: 'divider',
    path: `__divider__4`,
    hideInMenu: false, // keep it visible
    disabled: true,
    isDivider: true, // custom flag
    title: 'System', // text display
    access: 'isAdmin',
  },
  {
    path: '/ai-setting',
    name: 'setting',
    icon: 'SettingIcon',
    component: './AISetting',
    access: 'canAiSetting',
  },
  {
    path: '/diagnostics',
    name: 'diagnostics',
    icon: 'DiagnosticsIcon',
    component: './Diagnostics',
    access: 'canDiagnostics',
  },
  {
    path: '/management',
    name: 'management',
    icon: 'ManagementIcon',
    component: './User/Management',
    access: 'canManagement',
  },
  {
    path: '/organisation',
    name: 'organisation',
    icon: 'TeamIcon',
    component: './Organisation',
    access: 'isSuperAdmin',
  },
  {
    path: '/admin',
    name: 'admin',
    icon: 'AdminIcon',
    component: './AdminManagement',
    access: 'canAdmin',
  },
  {
    path: '/update-password',
    component: './User/ForcePasswordUpdate',
  },
  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '*',
    component: './404',
  },
];
